import { render } from "./shipping-card-edit.vue?vue&type=template&id=541abd5f"
import script from "./shipping-card-edit.vue?vue&type=script&lang=js"
export * from "./shipping-card-edit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__